import React from 'react'
import { Check } from 'phosphor-react'
import { ApprovedSealBadge, StatusPill } from './task-dashboard-styles'
import { getTaskStatusDisplay } from './task-dashboard-utils'

/** Renders status pill, or green seal-style Approved badge with tick. */
export const TaskStatusBadge = ({ task, isReportApproved = false }) => {
    const { label, variant } = getTaskStatusDisplay(task, isReportApproved)

    if (variant === 'approved') {
        return (
            <ApprovedSealBadge title="Approved">
                <span className="approved-seal-icon" aria-hidden>
                    <Check size={11} weight="bold" />
                </span>
                <span>Approved</span>
            </ApprovedSealBadge>
        )
    }

    return <StatusPill $variant={variant}>{label}</StatusPill>
}
